import {
    GET_FEATURED_ITEMS,
    ADD_FEATURED_ITEM,
    DELETE_FEATURED_ITEM,
    UPDATE_FEATURED_ITEM,
    FEATURED_ITEMS_LOADING,
    FEATURED_ITEMS_ERROR
} from '../Constants/FeaturedItemTypes';

const initialState = {
    items: [],
    loading: false,
    error: null
};

const featuredItemReducer = (state = initialState, action) => {
    switch (action.type) {
        case FEATURED_ITEMS_LOADING:
            return {
                ...state,
                loading: true
            };
        case GET_FEATURED_ITEMS:
            return {
                ...state,
                loading: false,
                items: action.payload
            };
        case ADD_FEATURED_ITEM:
            return {
                ...state,
                items: [action.payload, ...state.items]
            };
        case DELETE_FEATURED_ITEM:
            return {
                ...state,
                items: state.items.filter(item => item._id !== action.payload)
            };
        case UPDATE_FEATURED_ITEM:
            return {
                ...state,
                items: state.items.map(item =>
                    item._id === action.payload._id ? action.payload : item
                )
            };
        case FEATURED_ITEMS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
};

export default featuredItemReducer;
